// extracted by mini-css-extract-plugin
export default {"content":"DownloadAppModal_content__kFshW","okButton":"DownloadAppModal_okButton__OjE1X"};